export const prettifyPropertyName = (propertyName: string) => {
	// Replace underscores with spaces and capitalize the first letter of every part and minimalize rest
	return propertyName
		.split("_")
		.map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
		.join(" ");
};
